import styled from 'styled-components';
import { Paragraph } from '../Paragraph/Paragraph';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import { ReactComponent as ErgoSvg } from './assets/ErgoLogo.svg';
import { ReactComponent as InstagramSvg } from './assets/InstagramIcon.svg';
import { ReactComponent as LinkedInSvg } from './assets/LinkedInIcon.svg';
import { ReactComponent as FacebookSvg } from './assets/FacebookIcon.svg';

const Footer = () => {
  const CopyrightText = '© OnCampus Abroad, in collaboration with';

  const rrss = [
    {
      icon: InstagramSvg,
      Styled: InstagramIcon,
      href: 'https://www.instagram.com/oncampusabroad/',
      id: 'instagram',
    },
    {
      icon: LinkedInSvg,
      Styled: LinkedInIcon,
      href: 'https://www.linkedin.com/company/oncampus-abroad/',
      id: 'linkedin',
    },
    {
      icon: FacebookSvg,
      Styled: FacebookIcon,
      href: 'https://www.facebook.com/oncampusabroad',
      id: 'facebook',
    },
  ];

  const links = [
    {
      name: 'Legal Notice',
      href: '/legal-notice',
      id: 'nav-menu-/legal-notice',
    },
    {
      name: 'Privacy Policy',
      href: '/privacy-policy',
      id: 'nav-menu-/privacy-policy',
    },
    {
      name: 'Cookies Policy',
      href: '/cookies-policy',
      id: 'nav-menu-/cookies-policy',
    },
  ];

  return (
    <Background>
      <LandingWrapper>
        <FooterWrapper>
          <RRSSWrapper>
            {rrss.map(({ href, Styled, id }, index) => (
              <RRSSBackground
                key={index}
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                id={id}
              >
                <Styled />
              </RRSSBackground>
            ))}
          </RRSSWrapper>

          <LinksWrapper>
            {links.map(({ name, href, id }, index) => (
              <FooterLink key={index} href={href} id={id}>
                {name}
              </FooterLink>
            ))}
          </LinksWrapper>

          <CopyWraper>
            <CustomParagraph text={CopyrightText} color='light' />
            <ErgoIcon />
          </CopyWraper>
        </FooterWrapper>
      </LandingWrapper>
    </Background>
  );
};

export default Footer;

const Background = styled.div`
  width: 100%;
  background: #283288;
  margin-top: -20px;
`;

const CustomParagraph = styled(Paragraph)`
  font-size: 12px;
  padding: 0;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 46px 0 23px 0;
  gap: 38px;

  @media (min-width: 768px) {
    padding: 68px 0 48px 0;
    gap: 76px 0 56px;
    gap: 56px;
  }

  @media (min-width: 1024px) {
    padding: 55px 0 65px 0;
  }
`;

const CopyWraper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  @media (min-width: 768px) {
    gap: 11px;
  }
`;

const ErgoIcon = styled(ErgoSvg)`
  width: 22px;
  height: auto;

  @media (min-width: 768px) {
    width: 50px;
  }
`;

const LinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 22px;

  @media (min-width: 768px) {
    gap: 70px;
  }
`;

const FooterLink = styled.a`
  text-transform: uppercase;
  color: #fff6ef;
  font-size: 12px;
  font-family: 'League Spartan';
  font-weight: 400;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const RRSSBackground = styled.a`
  width: 45px;
  height: 45px;
  background: #fff6ef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    width: 69px;
    height: 69px;
  }
`;

const InstagramIcon = styled(InstagramSvg)`
  width: 22px;
  height: 22px;

  @media (min-width: 768px) {
    width: 34px;
    height: 34px;
  }
`;

const LinkedInIcon = styled(LinkedInSvg)`
  width: 20px;
  height: 20px;

  @media (min-width: 768px) {
    width: 31px;
    height: 31px;
  }
`;

const FacebookIcon = styled(FacebookSvg)`
  width: 11px;
  height: 24px;

  @media (min-width: 768px) {
    width: 17px;
    height: 37px;
  }
`;

const RRSSWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 37px;
`;
